import * as React from 'react'

interface CustomTextareaProps {
	text: string
	classes?: string
}

interface CustomTextareaStates {
	textareaHeight: number
}

export class CustomTextarea extends React.Component<CustomTextareaProps, CustomTextareaStates> {
	render() {
		let classes = this.props.classes ? this.props.classes : ''
		return (
			<div
				className={classes}
				style={{ wordWrap: 'break-word', height: 'auto' }}
			>
				{this.props.text}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CustomTextarea.tsx